export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export function addNotification(pMessage, pType) {
  return dispatch => {
    return dispatch({
      type: ADD_ERROR,
      message: {
        message: pMessage,
        type: pType
      }
    });
  }
}

export function removeNotification(index) {
  return dispatch => {
    return dispatch({
      index,
      type: REMOVE_ERROR
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/ErrorActions.js